import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { MenuItem } from '@web/shared/ui';

@Component({
  selector: 'app-header-mobile-menu-item',
  imports: [],
  templateUrl: './header-mobile-menu-item.component.html',
  styleUrl: './header-mobile-menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderMobileMenuItemComponent {
  public readonly item = input.required<MenuItem>();
}
